// extracted by mini-css-extract-plugin
export default {"container":"ss6HqA","title":"AWibpZ","subtitle":"ylPBQa"};